import React from 'react'
import DeleteButton from '../../buttons/DeleteButton'

const buttonDelete = ({ rowData, deleteItem, handleDelete }) => {
  const valueDeleted = deleteItem ? rowData : rowData?._id
  return (
    <div key={rowData?._id}>
      <DeleteButton onClick={() => handleDelete(valueDeleted)} />
    </div>
  )
}

const rowDelete = ({ handleDelete, deleteItem = false }) => {
  return {
    className: 'row-delete',
    rowEditor: 'rowEditor',
    body: (rowData) => buttonDelete({ rowData, deleteItem, handleDelete }),
    exportable: false,
  }
}

export default rowDelete
